module.exports = __webpack_public_path__ + "static/img/Opera.02b75e6.02b75e62.jpg";